module.exports = __webpack_public_path__ + "media/audio104.fc8909c7.mp3";